import { Node } from '@tiptap/pm/model';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

const variableDetect = (nodeText: string, position: number, decorations: Decoration[] = []) => {
    const variableRegex =
        /(?<!<code class="freemarker-highlight-variable">)(?<!<a\s[^>]*href="[^"]*)\[=[^[\]]*(?:\[[^[\]]*\])*[^[\]]*\](?!<\/code>)/g;
    parseExpression(
        nodeText,
        position,
        variableRegex,
        'freemarker-highlight-variable',
        decorations,
    );
};

const conditionDetect = (nodeText: string, position: number, decorations: Decoration[] = []) => {
    const conditionRegex =
        /(?<!<code class="freemarker-highlight-condition">)(\[#if(?:[^[\]]|\[(?:[^[\]]|\[[^[\]]*\])*\])*\])(?!<\/code>)/g;
    const elseRegex = /(?<!<code class="freemarker-highlight-condition">)(\[#else\])(?!<\/code>)/g;
    const endifRegex = /(?<!<code class="freemarker-highlight-condition">)(\[\/#if\])(?!<\/code>)/g;
    const cssClass = 'freemarker-highlight-condition';
    parseExpression(nodeText, position, conditionRegex, cssClass, decorations);
    parseExpression(nodeText, position, elseRegex, cssClass, decorations);
    parseExpression(nodeText, position, endifRegex, cssClass, decorations);
};

const parseExpression = (
    nodeText: string,
    position: number,
    regex: RegExp,
    cssClass: string,
    decorations: Decoration[] = [],
) => {
    Array.from(nodeText.matchAll(regex)).forEach((match) => {
        const sequence = match[0];
        const index = match.index || 0;
        const from = position + index;
        const to = from + sequence.length;
        const decoration = Decoration.inline(from, to, {
            class: cssClass,
            //style: `--color: ${color}`,
        });
        decorations.push(decoration);
    });
};

export default function (doc: Node): DecorationSet {
    const decorations: Decoration[] = [];

    doc.descendants((node, position) => {
        if (!node.text) {
            return;
        }
        variableDetect(node.text, position, decorations);
        conditionDetect(node.text, position, decorations);
    });

    return DecorationSet.create(doc, decorations);
}
